import script from "./SearchApp.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchApp.vue?vue&type=script&setup=true&lang=ts"

import "./SearchApp.vue?vue&type=style&index=0&id=5d7b9476&lang=css"

const __exports__ = script;

export default __exports__